// extracted by mini-css-extract-plugin
export var lg = "_38-4";
export var md = "_38-3";
export var sm = "_38-2";
export var xs = "_38-1";
export var xxs = "_38-0";